import { VueI18nHelper } from '@/helpers/VueI18nHelper';
import config from '../../../config';
import NewSingleProductPage from './NewSingleProductPage.vue';

VueI18nHelper.initVueI18NextMultipleForPage(
  NewSingleProductPage,
  `.new-single-product-vue`,
  [
    config.locize.webshopWordpress.namespaces.CART,
    config.locize.webshopWordpress.namespaces.ERRORS,
    config.locize.webshopWordpress.namespaces.LIMITING,
    config.locize.webshopWordpress.namespaces.PRODUCTSOVERVIEW,
    config.locize.products.namespaces.PRODUCTS_UFE,
  ],
  [
    {
      projectId: config.locize.webshopWordpress.PROJECTID,
      version: config.locize.webshopWordpress.version,
    },
    {
      projectId: config.locize.products.PROJECTID,
      version: config.locize.products.version,
    },
  ],
);
